import { AxiosHttpClient } from '../core/http/axios-http-client';
import { Validator } from '../features/validation/validator';
import {
  RegisterRequestSchema,
  AuthResponseSchema,
  type RegisterRequest,
  type AuthResponse,
} from '../features/validation/schemas';
import { ApiClientError } from '../core/errors/api-errors';
import { HttpError } from '../core/errors/http-error';

export async function register(
  baseUrl: string,
  workspaceId: string,
  userData: RegisterRequest,
  timeout?: number,
): Promise<AuthResponse> {
  const validatedUserData = Validator.validate(RegisterRequestSchema, userData);

  const apiUrl = `${baseUrl}/api/v1/${workspaceId}`;
  const httpClient = new AxiosHttpClient(apiUrl, timeout);

  try {
    const response = await httpClient.request<AuthResponse>({
      method: 'POST',
      url: '/register',
      data: validatedUserData,
    });

    return Validator.validate(AuthResponseSchema, response.data);
  } catch (error) {
    if (error instanceof HttpError) {
      throw new ApiClientError(error.message, error.statusCode);
    }

    throw error;
  }
}
